import createAsyncThunkFromFetch from '../../store/middlewares/createAsyncThunkFromFetch';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { fetchPhyDeviceApi, fetchPhyDevicesApi, updatePhyDeviceApi } from './api';
import { PhyDevice } from './types';

export const sliceName = 'phyDevices';

export const fetchPhyDevices = createAsyncThunkFromFetch(`${sliceName}/fetchPhyDevices`, fetchPhyDevicesApi);
export const fetchPhyDevice = createAsyncThunkFromFetch(`${sliceName}/fetchPhyDevice`, fetchPhyDeviceApi);
export const updatePhyDevice = createAsyncThunkFromFetch(`${sliceName}/updatePhyDevice`, updatePhyDeviceApi);

const deviceProviderAdapter = createEntityAdapter<PhyDevice>({
  selectId: device => device.id,
});

export const deviceSelectors = deviceProviderAdapter.getSelectors();

const providerSlice = createSlice({
  name: sliceName,
  initialState: {
    devices: deviceProviderAdapter.getInitialState(),
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchPhyDevices.fulfilled, (state, { payload }) => {
      deviceProviderAdapter.setAll(state.devices, payload);
    });
    builder.addCase(fetchPhyDevice.fulfilled, (state, { payload }) => {
      deviceProviderAdapter.upsertOne(state.devices, payload);
    });
    builder.addCase(updatePhyDevice.fulfilled, (state, { payload }) => {
      deviceProviderAdapter.upsertOne(state.devices, payload);
    });
  },
});

const { reducer } = providerSlice;

export default reducer;
